import { ThemeEvents } from '@theme/events';
import { Component } from '@theme/component';

/**
 * A custom element that displays a product price.
 * This component listens for variant update events and updates the price display accordingly.
 */
class ProductPrice extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  /**
   * Updates the price block when the variant changes.
   * @param {Event} event
   */
  updatePrice = (event) => {
    const html = event.detail?.data?.html;
    if (!html) return;

    let newProductPrice = null;

    if (this.dataset.blockId) {
      newProductPrice = html.querySelector(
        `product-price[data-block-id="${this.dataset.blockId}"]`
      );
    }

    if (!newProductPrice && this.dataset.productId) {
      newProductPrice = html.querySelector(
        `product-price[data-product-id="${this.dataset.productId}"]`
      );
    }

    if (!newProductPrice) {
      newProductPrice = html.querySelector('product-price');
    }

    if (!newProductPrice) return;

    this.replaceWith(newProductPrice.cloneNode(true));
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}